import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { useState } from "react";

const AddERPConfigModal = ({ erps, handleClose, setAddERP, erpConfigData }) => {
  const [selectedERP, setSelectedERP] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [connectionType, setConnectionType] = useState(null);
  const [oAuthUrl, setOAuthUrl] = useState(null);
  const [apiBaseUrl, setApiBaseUrl] = useState(null);
  const [tentId, setTentId] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [grantType, setGrantType] = useState(null);
  const [scope, setScope] = useState(null);


  const renderERPForm = () => {
    switch (selectedERP) {
      case "DynamicBC":
        return msbcForm();
      case "tallyPrime":
        return tallyForm();
      default:
        return null;
    }
  };

  const linkConfigData = () => {
    const erpData = {
      erp: selectedERP,
      company: companyName ? companyName : "",
      connection_type: connectionType ? connectionType.value : "",
      OauthUrl: oAuthUrl ? oAuthUrl : "",
      api_url_base_path: apiBaseUrl ? apiBaseUrl : "",
      tentId: tentId ? tentId : "",
      client_id: clientId ? clientId : "",
      client_secret: clientSecret ? clientSecret : "",
      scope: scope ? scope : "",
      grant_type: grantType ? grantType.value : "",
      status:"A"
    };
    erpConfigData(erpData);
  };

  const tallyForm = () => {
    return (
      <>
        <div>
          <InputGroup
            label="Company Name"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="Enter company name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </>,
            ]}
          />
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="API Base URL"
                  inputs={[
                    <>
                      <textarea
                        value={apiBaseUrl}
                        placeholder="Enter URL"
                        onChange={(e) => setApiBaseUrl(e.target.value)}
                        rows={4}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
        </div>
      </>
    );
  };

  const msbcForm = () => {
    return (
      <>
        <div>
          <InputGroup
            label="Company Name"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="Enter Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </>,
            ]}
          />
          <Dropdown
            label="Connection Type"
            options={[{ label: "OAuth", value: "OAuth" }].map(
              (connectiontype) => ({
                label: connectiontype.label,
                value: connectiontype.value,
              })
            )}
            onSelect={(value) => setConnectionType(value)}
            placeHolder={"Select Connection Type"}
            // selected={{ label: "OAuth", value: "OAuth" }}
          />
          <InputGroup
            label="OAuth URL"
            inputs={[
              <>
                <textarea
                  value={oAuthUrl}
                  placeholder="Enter URL"
                  onChange={(e) => setOAuthUrl(e.target.value)}
                />
              </>,
            ]}
          />
          <InputGroup
            label="API Base URL"
            inputs={[
              <>
                <textarea
                  value={apiBaseUrl}
                  placeholder="Enter URL"
                  onChange={(e) => setApiBaseUrl(e.target.value)}
                  rows={4}
                />
              </>,
            ]}
          />
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Tenent ID"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter tenent ID"
                        value={tentId}
                        onChange={(e) => setTentId(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Client ID"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter clientID"
                        value={clientId}
                        onChange={(e) => setClientId(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Client Secret"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter Client ID"
                        value={clientSecret}
                        onChange={(e) => setClientSecret(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Scope"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter scope"
                        value={scope}
                        onChange={(e) => setScope(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
          <Dropdown
            label="Grant Type"
            options={[
              {
                label: "client_credentials",
                value: "client_credentials",
              },
            ].map((connectiontype) => ({
              label: connectiontype.label,
              value: connectiontype.value,
            }))}
            onSelect={(value) => setGrantType(value)}
            placeHolder={" Enter Grant Type"}
            // selected={{
            //   label: "client_credentials",
            //   value: "client_credentials",
            // }}
          />
        </div>
      </>
    );
  };

  const addERPModal = () => {
    return (
      <Modal
        title="Add New ERP"
        headerActions={
          <CloseIcon
            onClick={() => {
              handleClose();
              setAddERP(false);
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                handleClose();
                setAddERP(false);
              }}
              label="Cancel"
            />
            <Button btnColor={buttoncss.primary} label="Config" />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <Dropdown
          label="Select ERP"
          options={erps}
          onSelect={(selected) => {
            setSelectedERP(selected.value);
          }}
          placeHolder={"Select ERP"}
        />
      </Modal>
    );
  };
  const erpConfigModal = () => {
    return (
      <Modal
        title="Configuration"
        width="40%"
        headerActions={
          <CloseIcon
            onClick={() => {
              handleClose();
              setAddERP(false);
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setSelectedERP(null);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label="Link ERP"
              onClick={linkConfigData}
            />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        {renderERPForm()}
      </Modal>
    );
  };

  return (
    <>
      {!selectedERP && addERPModal()}
      {selectedERP && erpConfigModal()}
    </>
  );
};

export default AddERPConfigModal;
